import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { config } from 'app/config';
import { user } from 'services';
import { useUiVersion } from 'hooks';
import { path } from 'router/sections';
import { LangSelector } from '../translation/lang-selector';
import { Tooltip } from '../tooltip/tooltip';
import { ThemeChanger } from '../theme-changer/theme-changer';
import { UiVersionSwitch } from '../ui-version-switch/ui-version-switch';
import { LayoutContainer, HeaderContainer, HeaderWrapper, BrandName, Login, LinksContainer, MenuLink, Right } from './layout.styled';
import { HeaderV2, BrandV2, BrandImg, NavStripV2, NavItemV2, RightV2, UserV2, AvatarV2 } from './layout.v2.styled';
import { getNavIcon } from './nav-icons';

export const Layout = ({ children, sections }) => {
  const { t } = useTranslation();
  const { isNew } = useUiVersion();

  /**
   * open external mnemo
   * @param {*} e
   */
  const openMnemonicDiagram = (e) => {
    e.preventDefault();
    const token = user.getToken();
    const popup = window.open(
      config.network.mnemonic_diagram_url + '?token=' + token,
      '_blank',
      'toolbar,scrollbars,resizable,top=110,left=0,width=' + window.screen.width + ',height=' + window.screen.height,
    );
    popup.moveTo(101, 101);
  };

  const menuSections = sections.filter((el) => el.type === 'section');

  const getMenuLinks = () => {
    return menuSections.map((el, idx) => (
      <MenuLink key={idx} to={el.path} onClick={el.id === 'scheme' ? openMnemonicDiagram : null}>
        {t('sections.' + el.name)}
      </MenuLink>
    ));
  };

  const userName = user.info ? user.info?.name : '';
  const initial = (userName || 'U').trim().charAt(0).toUpperCase();

  if (isNew) {
    return (
      <LayoutContainer>
        <HeaderV2>
          <BrandV2>
            <NavLink to={path('stays')}>
              <BrandImg src="/images/cleverpark.svg" alt="CLEVER PARK" />
            </NavLink>
          </BrandV2>
          <NavStripV2>
            {menuSections.map((el, idx) => (
              <NavItemV2 key={idx} to={el.path} title={t('sections.' + el.name)} onClick={el.id === 'scheme' ? openMnemonicDiagram : null}>
                {getNavIcon(el.id)}
                <span className="nav-label">{t('sections.' + el.name)}</span>
              </NavItemV2>
            ))}
          </NavStripV2>
          <RightV2>
            <UiVersionSwitch onDark />
            <ThemeChanger onDark />
            <LangSelector abs={false} onDark />
            <UserV2>
              <AvatarV2 aria-hidden title={userName}>
                {initial}
              </AvatarV2>
              <span className="uname">{userName}</span>
              <i className="fa fa-sign-out" title="Выйти" onClick={() => user.logoutUser()} />
            </UserV2>
          </RightV2>
        </HeaderV2>
        <>
          <Tooltip />
          {children}
        </>
      </LayoutContainer>
    );
  }

  return (
    <LayoutContainer>
      <HeaderContainer>
        <HeaderWrapper>
          <BrandName>
            <NavLink to={path('stays')}>
              <img src="/images/cleverpark.svg" alt="CLEVER PARK" />
            </NavLink>
          </BrandName>
          <LinksContainer>{getMenuLinks()}</LinksContainer>
          <Right>
            <UiVersionSwitch onDark />
            <ThemeChanger />
            <LangSelector abs={false} />
            <Login>
              {userName}
              <i className="fa fa-sign-out" onClick={() => user.logoutUser()} />
            </Login>
          </Right>
        </HeaderWrapper>
      </HeaderContainer>
      <>
        <Tooltip />
        {children}
      </>
    </LayoutContainer>
  );
};
